module.exports = __webpack_public_path__ + "c3ddb85a723c7125e7a6dd6f25bfbab4.svg";